import React from 'react';

export default function CircleEuro({ iconClass }: { iconClass?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 640 640"
      aria-hidden="true"
      focusable="false"
      role="img"
      className={iconClass}
    >
      <path d="M528 320c0-114.9-93.1-208-208-208s-208 93.1-208 208 93.1 208 208 208 208-93.1 208-208m-464 0C64 178.6 178.6 64 320 64s256 114.6 256 256-114.6 256-256 256S64 461.4 64 320m144.2-16H184v-32h32.1c19.6-51.5 69.5-88 127.8-88h57v48h-57c-31 0-58.3 15.9-74.2 40H336v32h-79.3c-1 5.4-1.6 11-1.6 16.8 0 5.2.4 10.3 1.3 15.2h79.5v32h-67.2a88.8 88.8 0 0 0 75.2 41.5h57v48h-57c-58.9 0-109.1-37.3-128.4-89.5H184v-32h24c-.6-5-.8-10.1-.8-15.2 0-5.7.3-11.3 1-16.8" />
    </svg>
  )
}
